import "./index.css";
import React from "react";
import { Skeleton } from "antd";
import { Link } from "react-router-dom";

interface TypeContainerProps {
  loading: boolean;
  children?: React.ReactNode;
}

/**
 * @name Container 仅负责布局
 */
const Container: React.FC<TypeContainerProps> = ({ loading, children }) => (
  <main className="layout-website layout-form-data">
    <header className="layout-website-header">
      <span>
        <Link to="/app/growthhub">Growth hub</Link>
      </span>
      <span>{">"}</span>
      <span>Bluerate & Personal site</span>
    </header>
    <div className="layout-website-content">
      <Skeleton active loading={loading}>
        {children}
      </Skeleton>
    </div>
  </main>
);

export default Container;
